const config = {
  apiEndpoint: "/api"
};

export default config;
